import { Injectable } from '@angular/core';
import { PatientHttpService } from './https/patient-http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPatient, Patient } from 'src/app/models/patient/patient.model';
import {IResultPatientGap, PatientGap, PatientGapResult} from "../../models/patient/patient-gap/patient-gap.model";
import {IResultPatientRisk, PatientRiskResult} from "../../models/patient/patient-risk/patient-risk.model";


@Injectable({
  providedIn: 'root'
})
export class PatientService {

  constructor(private patientHttpService: PatientHttpService) { }

  getPatientPractice(patientId: string, practiceId: string): Observable<Patient> {
    return this.patientHttpService
      .getPatientPractice(patientId, practiceId)
      .pipe(
        map((result: IPatient) =>  new Patient (result))
      );
  }

  getPatientGap(patientId: string): Observable<PatientGapResult> {
    return this.patientHttpService
      .getPatientGap(patientId)
      .pipe(
        map((result: IResultPatientGap) =>  new PatientGapResult (result))
      );
  }
  getPatientRisk(patientId: string): Observable<PatientRiskResult> {
    return this.patientHttpService
      .getPatientRisk(patientId)
      .pipe(
        map((result: IResultPatientRisk) =>  new PatientRiskResult (result))
      );
  }
updateNoShow(id:number,scheduleId:string, practiceId:string,providerId:string){
  return this.patientHttpService
    .updateNoShow(id,scheduleId,practiceId,providerId)
    .pipe(
      map((result: any) =>  result)
    );
}
  updateVisit(id:number,scheduleId:string, practiceId:string,providerId:string){
    return this.patientHttpService
      .updateVisit(id,scheduleId,practiceId,providerId)
      .pipe(
        map((result: any) =>  result)
      );
  }
  canceledVisit(id:number,scheduleId:string, practiceId:string,providerId:string){
    return this.patientHttpService
      .canceledVisit(id,scheduleId,practiceId,providerId)
      .pipe(
        map((result: any) =>  result)
      );
  }

  getIAPatient(memberPlanId: string){
    return this.patientHttpService
      .getIAPatient(memberPlanId)
      .pipe(
        map((result: any) =>  result)
      );
  }

  updateAppGap(id:number,providerId:string,practiceId:string):Observable<any>{
    return this.patientHttpService
      .updateAppGap(id,providerId,practiceId)
      .pipe(
        map((result: any) =>  result)
      );
  }
updateInactivePathology(id:number,practiceId:string,providerId:string):Observable<any>{
  return this.patientHttpService
    .updateInactivePathology(id,practiceId, providerId)
    .pipe(
      map((result: any) =>  result)
    );
}
  updateAppPathology(id:number,practiceId:string,providerId:string):Observable<any>{
    return this.patientHttpService
      .updateAppPathology(id,practiceId,providerId)
      .pipe(
        map((result: any) =>  result)
      );
  }

  addWalkIn(patientId:string, practiceId:string,providerId:string){
    return this.patientHttpService
      .addWalkIn(patientId,practiceId,providerId)
      .pipe(
        map((result: any) =>  result)
      );
  }

}
